import React from 'react'
import logoCentro from "../../media/icons/logoCentro.png"
import igIcon from "../../media/icons/igIcon.png"
import fbIcon from "../../media/icons/fbIcon.png"
import mailIcon from "../../media/icons/mailIcon.png"



function Footer() {
  return (
    <div className='brownBackground px-5 py-3 d-flex flex-row flex-wrap'>
        <div className='col-6 d-flex align-items-center justify-content-center'>
          <img width="100px" src={logoCentro} alt="logoCentro"/>
        </div>

        <div className='col-6'>
            <p className='text-white regularText col-12 text-center fs-4'>Redes Sociales:</p>
            <div className="d-flex flex-row gap-2 align-items-center justify-content-center">
              
              <a href='https://www.instagram.com/cefcf_unse/'><img width="40px" className="whiteImage" src={igIcon} alt="igIcon" /></a>
              <a href='https://www.facebook.com/cefcfunse/'><img width="40px" className="whiteImage" src={fbIcon} alt="fbIcon" /></a>
              <a href='centrodeestudiantesfcf@gmail.com'><img width="40px" className="whiteImage" src={mailIcon} alt="mailIcon" /></a>
            </div>
        </div>

        <div className='col-12 text-center mt-4'>
            <p className='text-white regularText'>Todos los derechos reservados.</p>
        </div>

    </div>
  )
}

export default Footer